import { render, staticRenderFns } from "./SubmissionTextEditor.vue?vue&type=template&id=3e72f66b&scoped=true"
import script from "./SubmissionTextEditor.vue?vue&type=script&lang=js"
export * from "./SubmissionTextEditor.vue?vue&type=script&lang=js"
import style0 from "./SubmissionTextEditor.vue?vue&type=style&index=0&id=3e72f66b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72f66b",
  null
  
)

export default component.exports